import React from "react";

export function Home() {
    return (
      <main>
        <section className="intro">
          <h1>Welcome to My Portfolio</h1>
          <p>
            Hello, I'm Shantanu Singh, a professional specializing in AI, Machine Learning, Cloud Computing, and Data Analytics.
            Explore my portfolio to learn more about my work and experience.
          </p>
        </section>
      </main>
    );
  }